import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Carousel} from "react-responsive-carousel";
import BASIOverallVIXSP from "../../components/Charts/BASI/BASIOverallVIXSP";
import BASIByTradeSize from "../../components/Charts/BASI/BASIByTradeSize";
import BASISectorIndexes from "../../components/Charts/BASI/BASISectorIndexes";
import BASISpecialtyIndexes from "../../components/Charts/BASI/BASISpecialtyIndexes";
import CPPBidAskSpread from "../../components/Charts/BASI/CPPBidAskSpread";
import CPPTreasuryBidAskSpread from "../../components/Charts/BASI/CPPTreasuryBidAskSpread";

class OnTheMarketCharts extends Component {

    static propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        match: PropTypes.object.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        history: PropTypes.object.isRequired
    };

    shouldComponentUpdate(nextProps){
        const currentPath = this.props.history.location.pathname.replace(`/${this.props.match.params.id}`, '');
        const updatedPath = nextProps.history.location.pathname.replace(`/${nextProps.match.params.id}`, '');

        return currentPath !== updatedPath;
    }

    updateHistory = sliderNumber => {
        const {id} = this.props.match.params;
        if (sliderNumber === id) return;
        const url = this.props.match.path.replace(':id', sliderNumber);
        this.props.history.push(url);
    };

    render() {
        const {id} = this.props.match.params;

        return (
            <div>
                <h2 style={{textAlign: 'center'}}>CP+ BASI</h2>
                <p>CP+ BASI is a group of indices that tracks bid-ask spreads across global credit, rates and emerging bond markets. These indices provide a useful gauge of general market liquidity as well as relative trading activity. When used alongside other market measures, the indices can yield valuable and actionable insights for various types of functions including trading strategy, portfolio construction and Transaction Costs Analysis (TCA).</p>
                <Carousel showArrows={false}
                          showIndicators={false}
                          swipeable={false}
                          emulateTouch={false}
                          showThumbs={false}
                          showStatus={false}
                          onChange={this.updateHistory}
                          selectedItem={Number(id)}>
                    <BASIOverallVIXSP/>
                    <BASIByTradeSize/>
                    <BASISectorIndexes/>
                    <BASISpecialtyIndexes/>
                    <CPPBidAskSpread/>
                    <CPPTreasuryBidAskSpread/>
                </Carousel>
                <p style={{fontSize: '12px'}}>
                    The Bid Ask Spread Index (the &quot;BASI Index&quot;) referred to herein and all information and data in
                    respect of such BASI Index are the proprietary material of MarketAxess, and are published on this
                    website for reference only. Any other use of the BASI Index is prohibited unless under the terms of
                    an express written license granted by MarketAxess. This prohibition includes but is not limited to
                    uses referred to in Article 3(1)(3) of EU Regulation 2016/1011 (the &quot;Benchmarks Regulation&quot;). This
                    notification serves to satisfy MarketAxess&#039;s obligations as an index-provider pursuant to Article
                    2(2)(h) of the Benchmarks Regulation. MarketAxess and each director, officer, employee,
                    representative, delegate and agent thereof hereby expressly disclaims, to the fullest extent
                    permitted by applicable law, any liability for any error, omission, interruption or delay relating
                    to the BASI Index as well as all warranties of accuracy, completeness, merchantability or fitness
                    for a particular purpose with respect to the BASI Index. MarketAxess shall not be under any
                    obligation to continue the calculation, publication and dissemination of the BASI Index and may
                    cease its calculation publication or dissemination at MarketAxess&#039;s discretion without notice.
                </p>
            </div>
        );
    }
}

export default OnTheMarketCharts;



// WEBPACK FOOTER //
// ./frontend/pages/Charts/TraceBASICharts.jsx